import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
const ShippingPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Header */}
      <section className="py-16 px-6 md:px-12 lg:px-24 border-b bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-semibold text-[#0f3e3e] mb-4">
            Shipping Policy
          </h1>
          <p className="text-muted-foreground">
            This Shipping Policy explains how Safety Training Institute delivers
            physical items related to our training programs.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto space-y-8 text-muted-foreground leading-relaxed">
          
          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              1. Shipping Items
            </h2>
            <p>We may ship the following physical items:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Printed training certificates (if applicable)</li>
              <li>Student ID cards</li>
              <li>Course study materials or manuals</li>
              <li>Other official institute documents</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              2. Shipping Areas
            </h2>
            <p>
              We currently provide shipping services across India. International
              shipping is not available unless specifically mentioned.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              3. Processing Time
            </h2>
            <p>
              Orders are processed within <strong>5–10 working days</strong>{" "}
              after course completion or payment confirmation.
            </p>
            <p>
              Processing time may vary due to holidays, verification delays, or
              administrative reasons.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              4. Delivery Time
            </h2>
            <p>
              Delivery time depends on the courier service and destination
              location. Typically, delivery takes{" "}
              <strong>7–15 working days</strong> after dispatch.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              5. Shipping Charges
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>
                Shipping charges, if applicable, will be communicated at the time
                of order.
              </li>
              <li>
                In some cases, shipping costs may be included in the course fee.
              </li>
              <li>Shipping charges are non-refundable.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              6. Tracking Information
            </h2>
            <p>
              Tracking details may be shared via SMS, WhatsApp, or email once the
              item is dispatched.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              7. Incorrect Address
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>
                Students are responsible for providing accurate shipping
                details.
              </li>
              <li>
                We are not responsible for delays or non-delivery due to
                incorrect addresses.
              </li>
              <li>
                Re-shipping charges may apply if items are returned.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              8. Damaged or Lost Items
            </h2>
            <p>
              In case of damaged or lost shipments, please contact us within{" "}
              <strong>48 hours</strong> of delivery. Resolution will depend on
              courier service policies.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              9. Digital Delivery
            </h2>
            <p>
              Digital certificates and course materials are delivered online
              through the student portal or email and do not require physical
              shipping.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              10. Policy Changes
            </h2>
            <p>
              Safety Training Institute reserves the right to update this
              Shipping Policy at any time. Changes will be posted on this page.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg text-[#0f3e3e] mb-2">
              11. Contact Information
            </h2>
            <p><strong>Institute Name:</strong> Safety Training Institute</p>
            <p><strong>Location:</strong> Bahanaga, Balasore, Odisha – 756042</p>
            <p><strong>Phone:</strong> 8280607556 / 9938232920</p>
            <p>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:info@safetytraininginstitute.org.in"
                className="text-[#0f3e3e] font-medium"
              >
                info@safetytraininginstitute.org.in
              </a>
            </p>
            <p>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.safetytraininginstitute.org.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0f3e3e] font-medium"
              >
                www.safetytraininginstitute.org.in
              </a>
            </p>
          </div>

        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default ShippingPolicy;
